
<!--
 * @Description: 教职工详情 工作简历
 * @Author: 张天伟
 * @Date: 2023-03-08 11:59:14
 * @LastEditors: PF
 * @LastEditTime: 2023-03-10 15:52:59
-->
<template>
  <div>
    <el-descriptions v-for="(item, index) in tableData" :key="index" :column="4" border>
      <el-descriptions-item label="工作起始日期" label-align="right" align="left" width="160px" span="2">{{item.gzqsrq}}</el-descriptions-item>
      <el-descriptions-item label="工作终止日期" label-align="right" align="left" width="160px" span="2">{{item.gzzzrq}}</el-descriptions-item>
      <el-descriptions-item label="工作单位" label-align="right" align="left" width="160px" span="2">{{item.gzdw}}</el-descriptions-item>
      <el-descriptions-item label="工作内容" label-align="right" align="left" width="160px" span="2">{{item.gznr}}</el-descriptions-item>
      <el-descriptions-item label="曾任党政职务" label-align="right" align="left" width="160px" span="2">{{item.crdzzw}}</el-descriptions-item>
      <el-descriptions-item label="曾任专业技术职务" label-align="right" align="left" width="160px" span="2">{{item.crzyjszw}}</el-descriptions-item>
      <el-descriptions-item label="工作证明人" label-align="right" align="left" width="160px" span="2">{{item.gzzmr}}</el-descriptions-item>
      <el-descriptions-item label="工作简历准备" label-align="right" align="left" width="160px" span="2">{{item.gzjlbz}}</el-descriptions-item>
    </el-descriptions>
  </div>
</template>

<script setup>
import { ref, defineProps, watch } from 'vue'
import { actionPost } from '@/api/common.js'

const props = defineProps({ row: { type: Object, required: false } })
const tableData = ref()

watch(
  () => props.row,
  () => {
    if (props.row) {
      const o = { url: '/api/v2/renliziyuan/jiaozhigonggongzuojianli/list', data: { id: props.row.id, order: 'gh', sort: 'asc' } }
      actionPost(o).then((res) => {
        tableData.value = res.data
      })
    }
  },
  { deep: true, immediate: true }
)
</script>
